import { useState } from "react";
import styled from "styled-components";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 100000001;
  width: 100vw;
  height: 100vh;

  .modal-section {
    position: fixed;
    top: 15vh;
    left: 35vw;
    width: 30vw;
    /* height: 44vh; */
    background-color: white;
    border-radius: 20px;
    overflow: hidden !important;
    z-index: 11;
    border: none;

    @media only screen and (min-width: 1401px) and (max-width: 1600px) {
      left: 35vw;
      width: 30vw;
    }

    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
      left: 30vw;
      width: 40vw;
    }

    @media only screen and (min-width: 992px) and (max-width: 1200px) {
      left: 30vw;
      width: 40vw;
    }

    @media only screen and (min-width: 768px) and (max-width: 991px) {
      left: 25vw;
      width: 50vw;
    }

    @media only screen and (min-width: 576px) and (max-width: 767px) {
      left: 17vw;
      width: 66vw;
    }

    @media only screen and (max-width: 575px) {
      left: 5vw;
      width: 90vw;
    }
  }

  .modal-header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #253d4e;

    @media only screen and (max-width: 575px) {
      font-size: 1rem;
    }

    & > i {
      font-size: 2rem;
      color: black;
      cursor: pointer;
      z-index: 12;
      :hover {
        color: #3bb77e;
      }

      @media only screen and (max-width: 575px) {
        font-size: 1.4rem;
      }
    }
  }

  .modal-content {
    height: auto;
    display: flex;
    justify-content: center;
    padding: 1rem;
    border: none;
    overflow-y: auto !important;
    z-index: 12;

    .pname-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
    }
  }
`;

const CartModal = ({
  cartModalOpen,
  setCartModalOpen,
  pickItem,
  pickItemName,
}) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") {
      setCartModalOpen(false);
    }
  };
  const item = JSON.parse(pickItem);

  const checkType = (el) => {
    if (Array.isArray(el.value)) {
      return el.value.map((el, i) => (
        <span key={i}>
          {el.name}:{" "}
          {(el.value === "large" && "대") ||
            (el.value === "medium" && "중") ||
            (el.value === "small" && "소")}
        </span>
      ));
    } else {
      return el.value;
    }
  };

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="modal-header">
            견적 상세보기
            <i
              className="fi-rs-circle-cross"
              onClick={() => setCartModalOpen(false)}
            />
          </div>
          <div className="modal-content">
            {pickItemName && (
              <div className="pname-wrapper">
                <h5 className="pname">{pickItemName}</h5>
              </div>
            )}
            <table>
              <thead>
                <tr>
                  <th style={{ width: "40%" }}>분류</th>
                  <th>내용</th>
                </tr>
              </thead>
              <tbody>
                {item.map((el, i) => (
                  <tr key={i}>
                    <td>{el.name}</td>
                    <td>{checkType(el)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div></div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export default CartModal;
